import * as React from 'react';
import CircularProgressMui, {
  CircularProgressProps as CircularProgressPropsMui,
} from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function CircularProgressWithLabel(
  props: CircularProgressPropsMui & { value: number }
) {
  return (
    <Box
      sx={{
        position: 'relative',
        display: 'inline-flex',
        borderWidth: 4,
        borderColor: '#d9d9d9',
        borderRadius: 999,
        width: 130,
        height: 130,
      }}
    >
      <CircularProgressMui
        variant="determinate"
        thickness={1.5}
        size={130}
        sx={{
          color: '#38a7b4',
          position: 'absolute',
          top: -4,
          left: -4,
          transform: 'rotate(0deg) !important',
        }}
        {...props}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          color="#38a7b4"
          fontFamily={'Neo Sans Arabic'}
          fontSize={25}
          fontWeight={700}
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}

interface CircularProgressProps {
  progress: number;
}

export const CircularProgress = ({ progress }: CircularProgressProps) => {
  return <CircularProgressWithLabel value={progress} />;
};
